<template>
    <div class="billing-main-scroll">
        <div class="billing-period-toggle">
            <button :class="['billing-period-btn', {'billing-period-btn--active': bs.state.billingPeriod === 'monthly'}]"
                    @click="bs.setBillingPeriod('monthly')">{{ $t('common.billing.monthly') }}</button>
            <button :class="['billing-period-btn', {'billing-period-btn--active': bs.state.billingPeriod === 'yearly'}]"
                    @click="bs.setBillingPeriod('yearly')">
                {{ $t('common.billing.yearly') }}
                <span class="billing-period-save">%20 {{ $t('common.billing.save') }}</span>
            </button>
        </div>

        <div class="billing-hero-banner">
            <div class="billing-hero-header">
                <span class="billing-hero-plan-name">{{ heroTitle }}</span>
                <span class="billing-hero-status">{{ bs.formatDate(bs.state.planExpiryDate) }}</span>
            </div>
            <div v-if="bs.activePlans.value.length > 1" class="billing-hero-tags">
                <span v-for="plan in bs.activePlans.value" :key="plan.id" class="billing-hero-tag">{{ plan.name }}</span>
            </div>
            <div class="billing-hero-meta">{{ planMeta }}</div>
        </div>

        <div class="billing-plans-grid">
            <div v-for="plan in bs.PLANS" :key="plan.id"
                 :class="['billing-plan-card', {'billing-plan-card--popular': plan.popular, 'billing-plan-card--active': bs.isPlanActive(plan.id)}]">
                <div class="billing-plan-accent" :style="{background: plan.color}"></div>
                <div class="billing-plan-body">
                    <div class="billing-plan-header">
                        <span class="billing-plan-name">{{ plan.name }}</span>
                        <span v-if="plan.popular" class="billing-plan-popular-badge">{{ $t('common.billing.popular') }}</span>
                        <span v-if="bs.isPlanActive(plan.id)" class="billing-plan-active-badge">{{ $t('common.billing.active') }}</span>
                    </div>
                    <div class="billing-plan-price">
                        <template v-if="bs.state.billingPeriod === 'yearly'">
                            <span class="billing-plan-old-price">{{ bs.formatPrice(plan.monthlyPrice) }}&#8378;</span>
                            <span class="billing-plan-amount">{{ bs.formatPrice(Math.round(plan.yearlyPrice / 12)) }}<span class="billing-plan-currency">&#8378;</span></span>
                            <span class="billing-plan-period">/{{ $t('common.billing.month') }}</span>
                        </template>
                        <template v-else>
                            <span class="billing-plan-amount">{{ bs.formatPrice(plan.monthlyPrice) }}<span class="billing-plan-currency">&#8378;</span></span>
                            <span class="billing-plan-period">/{{ $t('common.billing.month') }}</span>
                        </template>
                        <div v-if="bs.state.billingPeriod === 'yearly'" class="billing-plan-yearly-total">
                            <span class="billing-plan-save-tag">{{ $t('common.billing.yearlyTotal') }}: {{ bs.formatPrice(plan.yearlyPrice) }}&#8378;</span>
                        </div>
                    </div>
                    <div class="billing-plan-features">
                        <div v-for="(f, i) in plan.features" :key="i"
                             :class="['billing-plan-feature', {'billing-plan-feature--disabled': !f.included}]">
                            <span :class="['billing-plan-feature-icon', f.included ? 'billing-plan-feature-icon--check' : 'billing-plan-feature-icon--cross']">
                                <svg v-if="f.included" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                                <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                            </span>
                            <span>{{ f.text }}</span>
                        </div>
                    </div>
                    <button v-if="bs.isPlanActive(plan.id)" class="billing-plan-btn billing-plan-btn--current">
                        {{ $t('common.billing.currentPlan') }}
                    </button>
                    <button v-else class="billing-plan-btn billing-plan-btn--primary"
                            @click="bs.openCheckout({type: 'plan', name: plan.name + ' Plan', planId: plan.id, amount: bs.state.billingPeriod === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice})">
                        {{ $t('common.billing.buyNow') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingPackages',
    computed: {
        bs() {
            return billingService
        },
        heroTitle() {
            const plans = billingService.activePlans.value
            if (!plans.length) return ''
            if (plans.length === 1) return plans[0].name + ' Plan'
            return plans.length + ' Plan'
        },
        planMeta() {
            const plans = billingService.activePlans.value
            if (!plans.length) return ''
            const primary = plans[0]
            const f = primary.features
            return f.filter(x => x.included).map(x => x.text).slice(0, 3).join(' \u00B7 ')
        },
    },
}
</script>
